export const ExperimentGroupVariations = Object.freeze({
  CONTROL: 'control',
  VARIANT: 'variant',
});
